export const categories = [
  "All",
  "General Information",
  "Project & Process",
  "Pricing & Payments",
  "Technology & Security",
  "Support & Maintenance",
  "Ownership & Legal",
  "Getting Started",
];

 export const faqs = [
  {
    category: "General Information",
    question: "What services does TechQuitoes Solution  provide?",
    answer:
      "We offer custom software development, web and mobile app development, API integration, UI/UX design, cloud migration, testing, and maintenance.",
  },
  {
    category: "Project & Process",
    question: "How do I start a project with your team?",
    answer:
      "You can start by contacting us through our website. We’ll schedule a consultation to understand your goals and define scope and timelines.",
  },
  {
    category: "Pricing & Payments",
    question: "What payment methods do you accept?",
    answer:
      "We accept bank transfers, UPI, and international payments depending on your region and project agreement.",
  },
  {
    category: "Technology & Security",
    question: "What technologies do you use?",
    answer:
      "We use modern stacks like React, Node.js, Python, Django, AWS, Docker, and secure best practices for every project.",
  },
  {
    category: "Support & Maintenance",
    question: "Do you provide post-launch support?",
    answer:
      "Yes, we provide ongoing maintenance, monitoring, updates, and feature enhancements after deployment.",
  },
  {
    category: "Ownership & Legal",
    question: "Will I own the source code after project completion?",
    answer:
      "Yes, once the project is complete and payments are settled, full ownership of the code is transferred to you.",
  },
]; 